export function downloadCsvFile({
  content,
  fileName,
}: {
  content: string;
  fileName: string;
}): void {
  const blob = new Blob([content], { type: "text/csv; charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
